import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AgentPayouts() {
  const [data, setData] = useState({ items: [], approved_leads: 0, pending_leads: 0, total_paid: 0, total_pending: 0 });
  useEffect(() => { api.get("/agents/payouts").then(r => setData(r.data || {})).catch(()=>{}); }, []);

  const stats = [
    { label: "Total paid (₹)", value: Math.round(data.total_paid || 0) },
    { label: "Pending (₹)", value: Math.round(data.total_pending || 0) },
    { label: "Approved leads", value: data.approved_leads || 0 },
    { label: "Pipeline leads", value: data.pending_leads || 0 },
  ];

  return (
    <div>
      <div className="overline">Earnings</div>
      <h1 className="font-display text-3xl font-extrabold mt-1">My payouts</h1>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-3">
        {stats.map(s => (
          <div key={s.label} className="rounded-2xl bg-white border border-slate-200 p-5">
            <div className="text-[10px] uppercase tracking-[0.2em] text-ink-muted">{s.label}</div>
            <div className="font-display font-extrabold text-2xl sm:text-3xl mt-1">{Number(s.value).toLocaleString("en-IN")}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 card-flat p-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-ink-muted border-b border-slate-200">
            <th className="py-2 pr-3">Date</th><th className="py-2 pr-3">Amount</th><th className="py-2 pr-3">Status</th><th className="py-2 pr-3">Notes</th>
          </tr></thead>
          <tbody>
            {(data.items || []).length === 0 && <tr><td colSpan={4} className="py-10 text-center text-ink-muted">No payouts yet. Once your leads are approved & commission processed, they'll appear here.</td></tr>}
            {(data.items || []).map(p => (
              <tr key={p.id} className="border-b border-slate-100">
                <td className="py-3 pr-3 whitespace-nowrap text-xs">{new Date(p.created_at).toLocaleString("en-IN", { dateStyle: "medium" })}</td>
                <td className="py-3 pr-3 font-semibold">₹{Number(p.amount).toLocaleString("en-IN")}</td>
                <td className="py-3 pr-3"><span className={`text-xs px-2 py-0.5 rounded-full font-medium ${p.status === "Paid" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{p.status}</span></td>
                <td className="py-3 pr-3 text-xs text-ink-muted">{p.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
